module.exports = __webpack_public_path__ + "img/img67.c6bc55e7.svg";